import React, { useState } from 'react';
import { ModalBody, ClosePopup, ErrorUI, ModalBlack } from '../../../components/UI/Modals/Modals';
import { RowColoumn } from '../../../components/UI/Row/Row';
import { Button } from '../../../components/UI/Button/button';
import { toasterSubscriber, activityService } from '../../../services/subscriberService';
import { updateActivityStatus } from '../../../services/CallApi';
import { CustomRadio } from '../../../components/UI/FormInput/FormInput';
import { staticVar } from '../../../services/Constants';
import { CheckValue } from '../../../services/CommonFunction';
import SortIcon from '../../../components/ReusableComponents/SortIcon/SortIcon';
import PropTypes from 'prop-types';
import { ToggleUI } from '../../../components/UI/Toggle/Toggle';
import ToolTips from '../../../components/ReusableComponents/ToolTips/ToolTips';
import { selectIcon } from '../../../components/UI/selector';

export const RecurringScheduleActivity = (props) => {

    const [single, setSingle] = useState(null)
    return (
        <ModalBlack>
            {/* <ModalHeader title="Link Video" /> */}
            <ModalBody>
                <p className="popup_text1">{props.text || `This is a recurring ${staticVar.activity}. Do you wish to cancel?`}</p>
                <div className="radio_option">
                    {/* <CustomRadio name="screenLocation" radioValue={get('screenLocation').value} value={screenLocation[1]} change={el => setFormValue(el,mediaForm,'screenLocation')} /> */}
                    <CustomRadio radioValue={single} label={`This ${staticVar.activity}`} name="activity" value={true} change={el => setSingle(el)} />
                    <CustomRadio radioValue={single} label={`All ${staticVar.activities}`} name="activity" value={false} change={el => setSingle(el)} />
                </div>
                <RowColoumn style={{ justifyContent: 'center' }}>
                    <Button className="btns-defaults" label={props.cancelText || "cancel"} handleClick={ClosePopup} />
                    <Button invalid={single === null} handleClick={() => props.handleClick(single)} className="btns-primary" label={props.submitText || "OK"} />
                </RowColoumn>
            </ModalBody>
        </ModalBlack>
    )
}

export const changeView = (list) => {
    let data = {
        activity_id: list.id,
        is_published: !list.is_published
    };
    updateActivityStatus(data).then(res => {
        if (res.status) {
            toasterSubscriber.sendToasterData({
                showToaster: true,
                showImage: true,
                message: `${staticVar.Activity} ${!list.is_published ? 'Published' : 'Unpublished'} Successfully`
            });
            activityService.sendActivityMessage({ list: res.list, listKey: 'is_published', value: !list.is_published, status: 'update' });
        } else {
            ErrorUI(res.list, () => this.changeView(list));
        }
    })
}

export const VideoStatus = (props) => (
    <React.Fragment>
        {/* {!props.user.ondemandVideoStatus && CheckValue(props.user.playback_url) && <ToggleUI changeView={() => changeView(props.user)} text={["Published","Unpublished"]} value={props.user.is_published}  meta_id={props.user.id} />} */}
        {!props.user.ondemandVideoStatus && CheckValue(props.user.playback_url) && <ToggleUI clas="latestEnableDisable" changeView={() => changeView(props.user)} value={props.user.is_published} meta_id={props.user.id} text={['Published', 'Unpublished']} />}
        {(props.user.ondemandVideoStatus || !CheckValue(props.user.playback_url)) && <ToolTips position="top" message={props.user.ondemandVideoStatus ? "Video will be published in some time." : 'Error in uploading. Please go to the edit menu to try again.'} showTooltip={true}>
            <img className="info_icon" src={selectIcon('info')} alt="info" />
        </ToolTips>}
    </React.Fragment>
)

export const checkDate = (startDate, endDate, month = 3) => {
    startDate = setMonths(startDate, month);
    endDate = +new Date(endDate);
    return endDate > startDate
}

export const checkTime = (startDate, time = 5) => {
    const startDates = +new Date(startDate)
    const currentDates = +new Date().setMinutes(new Date().getMinutes() + time);
    return currentDates > startDates;
}

export const setMonths = (date = new Date().toDateString(), month = 3, plus = true) => (
    plus ?
        new Date(date).setMonth(new Date(date).getMonth() + month)
        :
        new Date(date).setMonth(new Date(date).getMonth() - month)
)

export const setTime = (date = new Date().toDateString(), time = 10, plus = true) => (
    plus ?
        new Date(date).setMinutes(new Date(date).getMinutes() + time)
        :
        new Date(date).setMinutes(new Date(date).getMinutes() - time)
)

export class CustomValidators {
    static endDateValidators = (AC) => {

        const type = AC.get('schedule_type').value;
        if (type === staticVar.oneDay) {
            return
        }

        const startDate = AC.get('startDate');
        const endDate = AC.get('endDate');


        if (checkDate(startDate.value, endDate.value)) {
            endDate.setErrors({ 'maxDate': true });
            return
        }

        if (endDate.errors === null) {
            return
        }

        // Remove matchPassword from existing errors
        const { maxDate, ...rest } = endDate.errors;
        if (!Object.keys(rest).length) {
            // Only our error was present mark as clean
            endDate.setErrors(null);
            return;
        }

        // Set remaining errors
        endDate.setErrors(rest);
    }

    static startTimeValidators = (AC) => {
        const type = AC.get('schedule_type').value;
        const activityId = AC.get('activityId');
        if (activityId.value !== null && type !== staticVar.oneDay) {
            return
        }

        const startDate = AC.get('startDate');

        if (checkTime(startDate.value)) {
            startDate.setErrors({ timeError: true });
            return
        }

        if (startDate.errors === null) {
            return
        }

        // Remove matchPassword from existing errors
        const { timeError, ...rest } = startDate.errors;
        if (!Object.keys(rest).length) {
            startDate.setErrors(null);
            return;
        }

        // Set remaining errors
        startDate.setErrors(rest);
    }
}

export const Navigate = (id) => {
    activityService.sendActivityMessage({ path: id, status: 'navigate' });
}

export const TitleWithSort = (props) => (
    <React.Fragment>
        {props.sort ? <SortIcon ascDesc={props.value} keys={props.status} ascDescClick={props.click} /> : null}
        {props.title}
    </React.Fragment>

)

TitleWithSort.propTypes = {
    sort: PropTypes.bool.isRequired
}

TitleWithSort.defaultProps = {
    sort: true,
    title: '',
    value: null,
    click: () => null,
    status: ''
}
